$(document).ready(function() {
	$("#metasearchCardBrandFeeSelect").change(function() {
		var baseAmount = parseFloat($("#metasearchCardBrandFeeTotalAmount").attr('totalAmount'));
		var amount = parseFloat($(this.options[this.selectedIndex]).attr("amount"));
		$("#metasearchCardBrandFeeTotalAmount").html((baseAmount+amount).toFixed(2));
		$("[name=metasearchCardBrandFee]").val($(this.options[this.selectedIndex]).val());
	}).change();
});